// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__28l9Z","errorLogs":"EditorFooter_errorLogs__taT1r"};